<script>
import FileUpload from 'primevue/fileupload';

export default {
    name: "AdaptersFileUpload",
    extends: FileUpload,
}
</script>
